import Cookie from 'js-cookie';

export default Cookie;
